<router-outlet></router-outlet>

<!-- Shared toast surface. Errors render through <arp-error-block> so severity, actions and
the reference line match every anchored surface; the success pill stays a plain chip.
Stacks up to three so a second failure can't silently replace the first. -->
<div id="error-display" [class.has-toasts]="toasts.length > 0">
  @for (toast of toasts; track toastTrackBy($index, toast)) {
    <div class="toast-slot" [class.show]="!toast.leaving" [class.hide]="toast.leaving">
      @if (toast.kind === 'success') {
        <div class="toast-pill">
          <svg lucideCheck aria-hidden="true"></svg>
          <span>{{ toast.message }}</span>
        </div>
      } @else {
        <arp-error-block
          variant="toast"
          [error]="toast.presented"
          [dismissible]="true"
          (actionInvoked)="onToastAction(toast, $event)"
          (dismissed)="dismissToast(toast)"
        ></arp-error-block>
      }
    </div>
  }
</div>
